import { Status } from '@/shared/types/Status';

export const CHIP_LABEL = {
  [Status.created]: 'Uploading',
  [Status.determineSpeakersDone]: 'Analyzing speakers',
  [Status.determineSpeakersFailed]: 'Determine speakers failed',
  [Status.determineSpeakersStarted]: 'Analyzing speakers',
  [Status.failed]: 'Error',
  [Status.forbiddenLink]: 'Forbidden link',
  [Status.mergingDone]: 'Video is generated',
  [Status.mergingFailed]: 'Merging failed',
  [Status.mergingStarted]: 'Generating video',
  [Status.noAudio]: 'Video has no sound',
  [Status.noWords]: 'Video lacks speech',
  [Status.separateBackgroundDone]: 'Analyzing video',
  [Status.separateBackgroundFailed]: 'Separate background failed',
  [Status.separateBackgroundStarted]: 'Analyzing video',
  [Status.transcribeSegmentsDone]: 'Analyzing SRT',
  [Status.transcribeSegmentsFailed]: 'Transcribe segments failed',
  [Status.transcribeSegmentsStarted]: 'Analyzing SRT',
  [Status.transcriptEdited]: 'Ready to generate video',
  [Status.transcriptionDone]: 'Transcripting video',
  [Status.transcriptionFailed]: 'Transcription failed',
  [Status.transcriptionStarted]: 'Transcripting video',
  [Status.translationDone]: 'Ready to generate video',
  [Status.translationFailed]: 'Translation failed',
  [Status.translationStarted]: 'Translating text',
  [Status.uploaded]: 'Uploading',
  [Status.uploadFailed]: 'Upload failed',
  [Status.uploading]: 'Uploading',
  [Status.voiceEdited]: 'Ready to generate video',
  [Status.voiceoverDone]: 'Generating video',
  [Status.voiceoverFailed]: 'Voiceover failed',
  [Status.voiceoverStarted]: 'Generating video',
  [Status.voiceSuggestDone]: 'Analyzing voices',
  [Status.voiceSuggestFailed]: 'Analyzing voices',
  [Status.voiceSuggestStarted]: 'Analyzing voices',
  [Status.voiceUpdateDone]: 'Ready to generate video',
  [Status.voiceUpdateFailed]: 'Ready to generate video',
  [Status.voiceUpdateStarted]: 'Voices analyzing',
} as const;

export const DST_SRT_UPLOADED_CHIP_LABEL = {
  [Status.created]: 'Uploading',
  [Status.determineSpeakersDone]: 'Analyzing speakers',
  [Status.determineSpeakersFailed]: 'Determine speakers failed',
  [Status.determineSpeakersStarted]: 'Analyzing speakers',
  [Status.failed]: 'Error',
  [Status.forbiddenLink]: 'Forbidden link',
  [Status.mergingDone]: 'Video is generated',
  [Status.mergingFailed]: 'Merging failed',
  [Status.mergingStarted]: 'Generating video',
  [Status.noAudio]: 'No audio',
  [Status.noWords]: 'No words',
  [Status.separateBackgroundDone]: 'Analyzing video',
  [Status.separateBackgroundFailed]: 'Separate background failed',
  [Status.separateBackgroundStarted]: 'Analyzing video',
  [Status.transcribeSegmentsDone]: 'Analyzing SRT',
  [Status.transcribeSegmentsFailed]: 'Transcribe segments failed',
  [Status.transcribeSegmentsStarted]: 'Analyzing SRT',
  [Status.transcriptEdited]: 'Ready to generate video',
  [Status.transcriptionFailed]: 'Transcription failed',
  [Status.translationFailed]: 'Translation failed',
  [Status.uploaded]: 'Uploading',
  [Status.uploadFailed]: 'Upload failed',
  [Status.uploading]: 'Uploading',
  [Status.voiceEdited]: 'Ready to generate video',
  [Status.voiceoverDone]: 'Generating video',
  [Status.voiceoverFailed]: 'Voiceover failed',
  [Status.voiceoverStarted]: 'Generating video',
  [Status.voiceSuggestDone]: 'Ready to generate video',
  [Status.voiceSuggestFailed]: 'Ready to generate video',
  [Status.voiceSuggestStarted]: 'Analyzing voices',
  [Status.voiceUpdateDone]: 'Ready to generate video',
  [Status.voiceUpdateFailed]: 'Ready to generate video',
  [Status.voiceUpdateStarted]: 'Analyzing voices',
} as const;

export const AUTOGENERATION_CHIP_LABEL = {
  [Status.created]: 'Uploading',
  [Status.determineSpeakersDone]: 'Analyzing speakers',
  [Status.determineSpeakersFailed]: 'Determine speakers failed',
  [Status.determineSpeakersStarted]: 'Analyzing speakers',
  [Status.failed]: 'Error',
  [Status.forbiddenLink]: 'Forbidden link',
  [Status.mergingDone]: 'Video is generated',
  [Status.mergingFailed]: 'Merging failed',
  [Status.mergingStarted]: 'Generating video',
  [Status.noAudio]: 'No audio',
  [Status.noWords]: 'No words',
  [Status.separateBackgroundDone]: 'Analyzing video',
  [Status.separateBackgroundFailed]: 'Separate background failed',
  [Status.separateBackgroundStarted]: 'Analyzing video',
  [Status.transcribeSegmentsDone]: 'Analyzing SRT',
  [Status.transcribeSegmentsFailed]: 'Transcribe segments failed',
  [Status.transcribeSegmentsStarted]: 'Analyzing SRT',
  [Status.transcriptEdited]: 'Generating video',
  [Status.transcriptionDone]: 'Transcripting video',
  [Status.transcriptionFailed]: 'Transcription failed',
  [Status.transcriptionStarted]: 'Transcripting video',
  [Status.translationDone]: 'Translating text',
  [Status.translationFailed]: 'Translation failed',
  [Status.translationStarted]: 'Translating text',
  [Status.uploaded]: 'Uploading',
  [Status.uploadFailed]: 'Upload failed',
  [Status.uploading]: 'Uploading',
  [Status.voiceEdited]: 'Generating video',
  [Status.voiceoverDone]: 'Generating video',
  [Status.voiceoverFailed]: 'Voiceover failed',
  [Status.voiceoverStarted]: 'Generating video',
  [Status.voiceSuggestDone]: 'Analyzing voices',
  [Status.voiceSuggestFailed]: 'Analyzing voices',
  [Status.voiceSuggestStarted]: 'Analyzing voices',
  [Status.voiceUpdateDone]: 'Generating video',
  [Status.voiceUpdateFailed]: 'Ready to generate video',
  [Status.voiceUpdateStarted]: 'Generating video',
} as const;
